<template>
  <div class="container">
    <!--banner-->
    <div class="nban pc">
      <img src="@/view/images/y48.jpg" />
    </div>
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">案例</a></p>
      </div>
    </div> -->
    <!--案例页-->
    <!-- <div class="neiy">
      <div class="commen">
        <div class="bt reveal-usercasetop">
          <h6>案例</h6>
          <img src="@/view/images/y8.png" />
        </div>
        <div class="all">
          <div class="ald fl reveal-usercasetop">
            <a href="#">
              <img src="@/view/images/y22.png" />
              <h6>一瞬网络 / 青岛市</h6>
              <p>
                青岛一瞬网络科技是国家级高新技术企业<br />主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务
              </p>
            </a>
          </div>
          <div class="ald fl reveal-usercasetop">
            <a href="#">
              <img src="@/view/images/y22.png" />
              <h6>一瞬网络 / 青岛市</h6>
              <p>
                青岛一瞬网络科技是国家级高新技术企业<br />主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务
              </p>
            </a>
          </div>
          <div class="ald fl reveal-usercasetop">
            <a href="#">
              <img src="@/view/images/y22.png" />
              <h6>一瞬网络 / 青岛市</h6>
              <p>
                青岛一瞬网络科技是国家级高新技术企业<br />主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务
              </p>
            </a>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <ca-se></ca-se>
    <!--留言-->
    <!-- <div class="lyan reveal-usercasetop">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text"  onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>

<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';
import CaSe from '@/components/case';

export default {
  name: 'caseName',
  components: {
    CounSel,
    CaSe,
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/usercase.vue